// Booking form builder schemas (architecture.md §8.3 form_questions, §24 M4).
import { z } from 'zod';
import { uuid } from './common.js';
import { FORM_INPUT_TYPE } from '../enums.js';

const CHOICE_TYPES = new Set(['select', 'radio', 'checkbox']);

export const formQuestionSchema = z
  .object({
    // null event_type_id = applies to all services.
    event_type_id: uuid.optional().nullable(),
    label: z.string().trim().min(1).max(240),
    input_type: z.enum(FORM_INPUT_TYPE).default('text'),
    placeholder: z.string().trim().max(160).optional().nullable(),
    help_text: z.string().trim().max(400).optional().nullable(),
    required: z.boolean().default(false),
    options: z.array(z.string().trim().min(1).max(160)).max(50).optional().nullable(),
    sort_order: z.number().int().min(0).default(0),
  })
  .superRefine((q, ctx) => {
    if (CHOICE_TYPES.has(q.input_type) && (!q.options || q.options.length === 0)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['options'],
        message: `input_type "${q.input_type}" requires at least one option`,
      });
    }
  });

export const updateFormQuestionSchema = formQuestionSchema;
